import { VERSION } from '@/lib/version';
/** Page d'accueil : deux profils (l'assuré n'y passe jamais : il arrive par son lien ou /declaration). */
import { Link, Navigate } from 'react-router-dom';
import { ClipboardList, Tablet } from 'lucide-react';
import { useSession } from '@/hooks/useSession';

const PROFILS = [
  {
    cle: 'assistant', titre: 'Assistant', icone: ClipboardList,
    texte: "Je reçois les missions des compagnies, je qualifie les dossiers et j'affecte l'expert et le rendez-vous.",
  },
  {
    cle: 'expert', titre: 'Expert', icone: Tablet,
    texte: 'Je prépare mes rendez-vous, je fais la visite et le chiffrage, puis je valide et j\'exporte le rapport.',
  },
] as const;

export function AccueilPage() {
  const { session } = useSession();
  if (session) return <Navigate to="/espace" replace />;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-muted/30 p-4">
      <div className="text-center">
        <h1 className="text-3xl font-semibold">Les Experts <span className="align-middle text-base font-normal text-muted-foreground">{VERSION}</span></h1>
        <p className="mt-1 text-muted-foreground">Expertise des biens volés ou endommagés</p>
      </div>
      <div className="grid w-full max-w-3xl gap-4 sm:grid-cols-2">
        {PROFILS.map((p) => (
          <Link key={p.cle} to={`/connexion?profil=${p.cle}`}
            className="group rounded-2xl border bg-card p-6 shadow-sm transition hover:border-primary hover:shadow-md">
            <p.icone className="size-10 text-primary" />
            <h2 className="mt-4 text-xl font-semibold">{p.titre}</h2>
            <p className="mt-2 text-sm text-muted-foreground">{p.texte}</p>
            <span className="mt-4 inline-block text-sm font-medium text-primary group-hover:underline">Se connecter →</span>
          </Link>
        ))}
      </div>
      <p className="text-sm text-muted-foreground">
        Vous êtes assuré ? <Link to="/declaration" className="font-medium underline">Accédez à votre dossier</Link>
      </p>
      <Link to="/connexion?profil=admin" className="text-xs text-muted-foreground underline">Administration du cabinet</Link>
    </div>
  );
}
